import { StatusBadgeComponent } from './status-badge.component';

export default angular
  .module('sfMobile.components.status-badge', [])
  .component('sfStatusBadge', StatusBadgeComponent).name;
